(() => {
  if (window.__abastikWholesaleReady) return;
  window.__abastikWholesaleReady = true;

  const money = (value) => new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    maximumFractionDigits: 0
  }).format(Math.max(0, Number(value) || 0));

  const toInt = (value, fallback = 1) => {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const getPricing = (root, qty) => {
    const type = root.dataset.productType;
    const t1Price = toInt(root.dataset.tier1Price, 0);
    const t1Max = toInt(root.dataset.tier1Max, 1);
    const t2Price = toInt(root.dataset.tier2Price, t1Price);
    const t2Min = toInt(root.dataset.tier2Min, t1Max + 1);
    const t3Price = toInt(root.dataset.tier3Price, t2Price);
    const t3Min = toInt(root.dataset.tier3Min, t2Min + 1);

    if (type === 'primera') {
      const t4Price = toInt(root.dataset.tier4Price, t3Price);
      const t4Min = toInt(root.dataset.tier4Min, t3Min + 1);
      if (qty >= t4Min) return { tier: 4, price: t4Price, label: `${t4Min}+ cajas`, next: null };
      if (qty >= t3Min) return { tier: 3, price: t3Price, label: `${t3Min}–${t4Min - 1} cajas`, next: { qty: t4Min, price: t4Price } };
      if (qty >= t2Min) return { tier: 2, price: t2Price, label: `${t2Min}–${t3Min - 1} cajas`, next: { qty: t3Min, price: t3Price } };
      return { tier: 1, price: t1Price, label: `1–${t1Max} cajas`, next: { qty: t2Min, price: t2Price } };
    }

    if (qty >= t3Min) return { tier: 3, price: t3Price, label: `${t3Min}+ cajas`, next: null };
    if (qty >= t2Min) return { tier: 2, price: t2Price, label: `${t2Min}–${t3Min - 1} cajas`, next: { qty: t3Min, price: t3Price } };
    return { tier: 1, price: t1Price, label: `1–${t1Max} cajas`, next: { qty: t2Min, price: t2Price } };
  };

  const updateProgress = (range) => {
    const min = Number(range.min) || 1;
    const max = Number(range.max) || 30;
    const value = Math.min(max, Math.max(min, Number(range.value) || min));
    const percentage = ((value - min) / Math.max(1, max - min)) * 100;
    range.style.setProperty('--ab-range-fill', `${percentage}%`);
  };

  const initWholesale = (root) => {
    if (root.dataset.abWholesaleReady === 'true') return;
    root.dataset.abWholesaleReady = 'true';

    const article = root.closest('article') || root.closest('[data-product-card]') || root.parentElement;
    const qtyInput = root.querySelector('[data-ab-qty-input]');
    const range = root.querySelector('[data-ab-range]');
    const minus = root.querySelector('[data-ab-minus]');
    const plus = root.querySelector('[data-ab-plus]');
    const unitPrice = root.querySelector('[data-ab-unit-price]');
    const total = root.querySelector('[data-ab-total]');
    const savingWrap = root.querySelector('[data-ab-saving-wrap]');
    const saving = root.querySelector('[data-ab-saving]');
    const tierLabel = root.querySelector('[data-ab-tier-label]');
    const nextMessage = root.querySelector('[data-ab-next-message]');
    const tierCards = Array.from(root.querySelectorAll('[data-ab-tier-card]'));
    const formQty = article?.querySelector('form[action*="/cart/add"] input[name="quantity"], .quick-form input[name="quantity"]');
    const basePrice = toInt(root.dataset.tier1Price, 0);
    const sliderMax = toInt(root.dataset.sliderMax, 30);

    const render = (requestedQty) => {
      const qty = Math.min(999, Math.max(1, toInt(requestedQty, 1)));
      const pricing = getPricing(root, qty);
      qtyInput.value = qty;
      range.value = Math.min(sliderMax, qty);
      if (formQty) formQty.value = qty;
      unitPrice.textContent = money(pricing.price);
      total.textContent = money(pricing.price * qty);
      tierLabel.textContent = pricing.label;

      tierCards.forEach((card) => {
        card.classList.toggle('is-active', toInt(card.dataset.abTierCard, 0) === pricing.tier);
      });

      const savingValue = Math.max(0, (basePrice - pricing.price) * qty);
      if (savingWrap) savingWrap.hidden = savingValue <= 0;
      if (saving) saving.textContent = money(savingValue);

      if (pricing.next) {
        const missing = Math.max(0, pricing.next.qty - qty);
        nextMessage.innerHTML = `Agrega <strong>${missing} ${missing === 1 ? 'caja' : 'cajas'} más</strong> y baja a <strong>${money(pricing.next.price)} por caja</strong>.`;
      } else {
        nextMessage.innerHTML = `<strong>¡Mejor precio mayorista desbloqueado!</strong> Ya estás pagando ${money(pricing.price)} por caja.`;
      }
      updateProgress(range);
    };

    minus?.addEventListener('click', () => render(toInt(qtyInput.value) - 1));
    plus?.addEventListener('click', () => render(toInt(qtyInput.value) + 1));
    qtyInput?.addEventListener('input', () => render(qtyInput.value));
    qtyInput?.addEventListener('change', () => render(qtyInput.value));
    range?.addEventListener('input', () => render(range.value));
    render(1);
  };

  const burstConfetti = (button) => {
    if (!button || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    button.classList.remove('is-ab-confetti-click');
    void button.offsetWidth;
    button.classList.add('is-ab-confetti-click');
    window.setTimeout(() => button.classList.remove('is-ab-confetti-click'), 520);
    const rect = button.getBoundingClientRect();
    const container = document.createElement('div');
    container.className = 'ab-cart-confetti';
    container.style.left = `${rect.left + rect.width / 2}px`;
    container.style.top = `${rect.top + rect.height / 2}px`;
    document.body.appendChild(container);

    const colors = ['#00026e', '#f3c544', '#ffffff', '#0c2d88'];
    const pieces = 24;
    for (let i = 0; i < pieces; i += 1) {
      const piece = document.createElement('i');
      const angle = (Math.PI * 2 * i) / pieces + (Math.random() - .5) * .4;
      const distance = 46 + Math.random() * 90;
      const x = Math.cos(angle) * distance;
      const y = Math.sin(angle) * distance - 22;
      piece.style.setProperty('--x', `${x}px`);
      piece.style.setProperty('--y', `${y}px`);
      piece.style.setProperty('--r', `${Math.round(Math.random() * 520 - 260)}deg`);
      piece.style.setProperty('--delay', `${Math.random() * 80}ms`);
      piece.style.background = colors[i % colors.length];
      if (i % 7 === 0) {
        piece.classList.add('is-egg');
        piece.textContent = '🥚';
        piece.style.background = 'transparent';
      }
      container.appendChild(piece);
    }
    window.setTimeout(() => container.remove(), 1100);
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-ab-wholesale]').forEach(initWholesale);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.ab-products-quantity-wholesale .add-cart, .ab-products-quantity-wholesale button[name="add"], .ab-products-quantity-wholesale .add-to-cart-button');
    if (button && !button.disabled) burstConfetti(button);
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
